'use es6';

/* Auth */
export const SET_AUTH = 'SET_AUTH';

/* Drag and drop */
export const SET_NODE_HOVER_POSITION = 'SET_NODE_HOVER_POSITION';

/* Menu Tree */
export const MENU_TREE_LOAD = 'MENU_TREE_LOAD';
export const MENU_TREE_MOVE_NODE = 'MENU_TREE_MOVE_NODE';
export const MENU_TREE_ADD_NODE = 'MENU_TREE_ADD_NODE';
export const MENU_TREE_ADD_CHILD = 'MENU_TREE_ADD_CHILD';
export const MENU_TREE_ADD_NODE_TO_BOTTOM = 'MENU_TREE_ADD_NODE_TO_BOTTOM';
export const MENU_TREE_CLONE_NODE = 'MENU_TREE_CLONE_NODE';
export const MENU_TREE_DELETE_NODE = 'MENU_TREE_DELETE_NODE';
export const MENU_TREE_DELETE_TREE = 'MENU_TREE_DELETE_TREE';

/* Menu Nodes */
export const MENU_NODE_UPDATE = 'MENU_NODE_UPDATE';
export const MENU_NODE_UPDATE_PAGE_LINK_ID = 'MENU_NODE_UPDATE_PAGE_LINK_ID';
export const MENU_NODE_REPLACE = 'MENU_NODE_REPLACE';

/* Pages */
export const PAGES_FETCH = 'PAGES_FETCH';
export const PAGES_SAVE_CACHED_PAGE = 'PAGES_SAVE_CACHED_PAGE';
export const PAGES_CACHE_CLEAR = 'PAGES_CACHE_CLEAR';
export const PAGES_FETCH_BY_ID = 'PAGES_FETCH_BY_ID';

/* Application */
export const SET_IS_DRAGGING = 'SET_IS_DRAGGING';